<template>
  <div>
    <div class="main">
      <DataTablePage
        resource="waterMeter.json"
        title="巡查情况"
        dialogSize="tiny"
        :relation="false"
        :toolbar="toolbar"
        :operation="operation"
        :autoIndex="false"
        :tableFullList="tableFullList"
        :tableInitList="tableInitList"
        :filterFullList="filterFullList"
        :filterInitList="filterInitList"
        :columns="columns"
        >
      </DataTablePage>
    </div>
  </div>
</template>

<script>
import DataTablePage from '@/containers/DataTablePage'
import { toolbarExport } from '@/containers/DataTablePage/toolbar'

export default {
  components: {
    DataTablePage
  },
  data () {
    return {
      toolbar: [toolbarExport],
      tableInitList: ['bookNum', 'customNum', 'customName', 'phone', 'quality', 'address', 'date', 'code', 'outerCode', 'caliber', 'range', 'status'],
      tableFullList: ['bookNum', 'customNum', 'customName', 'phone', 'quality', 'address', 'date', 'code', 'outerCode', 'caliber', 'range', 'status'],
      filterInitList: ['customNum', 'quality', 'date'],
      filterFullList: ['customNum', 'quality', 'date'],
      operation: [{
        label: '查看图片',
        func (data) {
        }
      }, {
        label: '发起工单',
        func () {
          console.log(999)
        }
      }],
      columns: {
        bookNum: {
          label: '区本号',
          width: 85
        },
        customNum: {
          label: '户号',
          width: 72,
          filter: {
            type: 'input',
            like: true
          }
        },
        customName: {
          label: '户名',
          width: 80
        },
        phone: {
          label: '手机',
          width: 150
        },
        quality: {
          label: '用水性质',
          type: 'input',
          width: 100,
          filter: {
            type: 'input'
          }
        },
        address: {
          label: '地址'
        },
        date: {
          label: '最后抄表时间',
          sort: true,
          width: 170,
          minLength: 20,
          type: 'time',
          dateType: 'YYYY-MM-DD HH:mm:ss',
          filter: {
            type: 'daterange'
          }
        },
        code: {
          label: '条形码',
          width: 85
        },
        outerCode: {
          label: '行码',
          width: 70
        },
        caliber: {
          label: '口径',
          width: 70
        },
        range: {
          label: '量程',
          width: 70
        },
        status: {
          label: '表况'
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?c2c4e3f2